<div class="mt-3" *ngIf="!dataStoreSetting.hideDeliverables">
  <mat-accordion>
    <mat-expansion-panel
      to
      id="intelligence-panel"
      class="w-100 mat-elevation-z0"
      style="background-color: transparent"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
      expanded="false"
    >
      <mat-expansion-panel-header
        class="custom-border custom-border-left bg-white shadow-sm"
      >
        <mat-panel-title
          class="d-flex align-items-center align-content-center gap-2"
        >
          <h2 class="fw-semibold m-0">Entregáveis</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row mt-3">
        <div class="mb-3 col-sm-12 col-md-6">
          <div class="card report-card mb-3 border-0 shadow-sm bg-white">
            <div class="card-body">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.5665 13.8074L20.9018 14.4721H18.7247L19.669 13.5277L16.7697 8.12324V30L10.4336 18.1914L11.0983 17.5267H13.2754L12.331 18.4711L15.2304 23.8756V2L21.5665 13.8074Z"
                  fill="#3199D0"
                />
                <path
                  d="M14.3558 15.2298H8.1244L13.5277 12.3305L14.3558 13.1579V10.9814L13.808 10.4336L2 16.7691H14.3558V15.2298Z"
                  fill="#3199D0"
                />
                <path
                  d="M29.9998 15.2305L18.1924 21.5654L17.644 21.0182V18.841L18.4721 19.6691L23.8749 16.7697H17.644V15.2305H29.9998Z"
                  fill="#3199D0"
                />
                <path
                  d="M8.61477 5.82321L7.52637 6.91162L9.69537 9.08062L10.7838 7.99222L8.61477 5.82321Z"
                  fill="#3199D0"
                />
                <path
                  d="M23.3843 5.82221L21.2153 7.99121L22.3037 9.07962L24.4727 6.91062L23.3843 5.82221Z"
                  fill="#3199D0"
                />
                <path
                  d="M9.69586 22.1832L7.52686 24.3522L8.61526 25.4406L10.7843 23.2716L9.69586 22.1832Z"
                  fill="#3199D0"
                />
                <path
                  d="M22.3047 22.1838L21.2163 23.2722L23.3853 25.4412L24.4737 24.3528L22.3047 22.1838Z"
                  fill="#3199D0"
                />
              </svg>
              <h2 class="card-title fw-semibold my-3">Pré-Reunião</h2>
              <p class="card-text m-0 p-0">
                Receba junto ao material de diagnóstico uma análise apurada de
                endividamento, orçamento, investimentos, necessidades e
                objetivos.
              </p>
            </div>
          </div>
        </div>

        <div class="mb-3 col-sm-12 col-md-6">
          <div class="card report-card mb-3 border-0 shadow-sm bg-white">
            <div class="card-body">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.615 6.21127C28.4952 6.11793 28.3557 6.0531 28.2072 6.02169C28.0586 5.99029 27.9048 5.99314 27.7575 6.03002L20.1162 7.94002L12.4475 4.10502C12.2338 3.99844 11.9891 3.97184 11.7575 4.03002L3.7575 6.03002C3.54116 6.08409 3.3491 6.20893 3.21185 6.38468C3.0746 6.56044 3.00003 6.77702 3 7.00002V25C3.00002 25.152 3.03467 25.3019 3.10132 25.4385C3.16797 25.575 3.26486 25.6946 3.38463 25.7881C3.50441 25.8816 3.64392 25.9466 3.79256 25.9781C3.94121 26.0096 4.09508 26.0069 4.2425 25.97L11.8837 24.06L19.5525 27.895C19.6917 27.9637 19.8448 27.9996 20 28C20.0818 28 20.1632 27.9899 20.2425 27.97L28.2425 25.97C28.4588 25.9159 28.6509 25.7911 28.7881 25.6154C28.9254 25.4396 29 25.223 29 25V7.00002C29 6.84792 28.9654 6.69783 28.8987 6.56115C28.8319 6.42447 28.7349 6.3048 28.615 6.21127ZM13 6.61752L19 9.61752V25.3825L13 22.3825V6.61752ZM5 7.78127L11 6.28127V22.2188L5 23.7188V7.78127ZM27 24.2188L21 25.7188V9.78127L27 8.28127V24.2188Z"
                  fill="#3199D0"
                />
              </svg>
              <h2 class="card-title fw-semibold my-3">
                Reunião 1: Planejamento
              </h2>
              <p class="card-text m-0 p-0">
                Definição do orçamento e projeção de conquistas. Foco em reduzir
                custos ocultos sem interferir no padrão de vida. Construção de
                sistema de recompensas por metas atingidas.
              </p>
            </div>
          </div>
        </div>

        <div class="mb-3 col-sm-12 col-md-6">
          <div class="card report-card mb-3 border-0 shadow-sm bg-white">
            <div class="card-body">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM16 27C13.8244 27 11.6977 26.3549 9.88873 25.1462C8.07979 23.9375 6.66989 22.2195 5.83733 20.2095C5.00477 18.1995 4.78693 15.9878 5.21137 13.854C5.63581 11.7202 6.68345 9.7602 8.22183 8.22183C9.76021 6.68345 11.7202 5.6358 13.854 5.21136C15.9878 4.78692 18.1995 5.00476 20.2095 5.83733C22.2195 6.66989 23.9375 8.07979 25.1462 9.88873C26.3549 11.6977 27 13.8244 27 16C26.9967 18.9164 25.8367 21.7123 23.7745 23.7745C21.7123 25.8367 18.9164 26.9967 16 27ZM21 18.5C21 19.4283 20.6313 20.3185 19.9749 20.9749C19.3185 21.6313 18.4283 22 17.5 22H17V23C17 23.2652 16.8946 23.5196 16.7071 23.7071C16.5196 23.8946 16.2652 24 16 24C15.7348 24 15.4804 23.8946 15.2929 23.7071C15.1054 23.5196 15 23.2652 15 23V22H13C12.7348 22 12.4804 21.8946 12.2929 21.7071C12.1054 21.5196 12 21.2652 12 21C12 20.7348 12.1054 20.4804 12.2929 20.2929C12.4804 20.1054 12.7348 20 13 20H17.5C17.8978 20 18.2794 19.842 18.5607 19.5607C18.842 19.2794 19 18.8978 19 18.5C19 18.1022 18.842 17.7206 18.5607 17.4393C18.2794 17.158 17.8978 17 17.5 17H14.5C13.5717 17 12.6815 16.6313 12.0251 15.9749C11.3688 15.3185 11 14.4283 11 13.5C11 12.5717 11.3688 11.6815 12.0251 11.0251C12.6815 10.3687 13.5717 10 14.5 10H15V9C15 8.73478 15.1054 8.48043 15.2929 8.29289C15.4804 8.10536 15.7348 8 16 8C16.2652 8 16.5196 8.10536 16.7071 8.29289C16.8946 8.48043 17 8.73478 17 9V10H19C19.2652 10 19.5196 10.1054 19.7071 10.2929C19.8946 10.4804 20 10.7348 20 11C20 11.2652 19.8946 11.5196 19.7071 11.7071C19.5196 11.8946 19.2652 12 19 12H14.5C14.1022 12 13.7206 12.158 13.4393 12.4393C13.158 12.7206 13 13.1022 13 13.5C13 13.8978 13.158 14.2794 13.4393 14.5607C13.7206 14.842 14.1022 15 14.5 15H17.5C18.4283 15 19.3185 15.3687 19.9749 16.0251C20.6313 16.6815 21 17.5717 21 18.5Z"
                  fill="#3199D0"
                />
              </svg>

              <h2 class="card-title fw-semibold my-3">
                Reunião 2: Investimentos
              </h2>
              <p class="card-text m-0 p-0">
                Elaboração da sua estratégia de investimentos. Além disso,
                quando fizer sentido, é o momento de conectar diretamente à
                gestora no modelo de Wealth Management.
              </p>
            </div>
          </div>
        </div>

        <div class="mb-3 col-sm-12 col-md-6">
          <div class="card report-card mb-3 border-0 shadow-sm bg-white">
            <div class="card-body">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V14.3462C4 25.5475 13.4775 29.2637 15.375 29.895C15.7803 30.0328 16.2197 30.0328 16.625 29.895C18.525 29.2637 28 25.5475 28 14.3462V7C28 6.46957 27.7893 5.96086 27.4142 5.58579C27.0391 5.21071 26.5304 5 26 5ZM26 14.3487C26 24.1512 17.7063 27.4262 16 27.9962C14.3088 27.4325 6 24.16 6 14.3487V7H26V14.3487Z"
                  fill="#3199D0"
                />
              </svg>

              <h2 class="card-title fw-semibold my-3">Reunião 3: Proteções</h2>
              <p class="card-text m-0 p-0">
                Mapeamento de necessidades de proteção e estratégias avançadas
                (portabilidade e eficiência tributária) de previdência privada.
              </p>
            </div>
          </div>
        </div>

        <div class="col mb-3">
          <div class="card bg-white border-0 shadow-sm">
            <div class="row g-0 m-2 mb-3">
              <div class="col-md-6">
                <div class="card-body">
                  <div class="row">
                    <div class="flex justify-content-start mt-2 mb-4">
                      <svg
                        width="25"
                        height="28"
                        viewBox="0 0 25 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2531_1234)">
                          <path
                            d="M9.07834 0C4.07245 0 0 4.07245 0 9.07834V10.4639H6.69143V18.6397C6.69143 23.8012 10.9057 28 16.0869 28H17.4441V13.9072H17.4544V10.4639H19.0747C21.985 10.4639 24.353 8.0959 24.353 5.18554V0H9.07834ZM14.7289 25.1575C11.6947 24.5318 9.40668 21.8466 9.40668 18.6397V10.4639H14.7194V13.9072H14.7289V25.1575ZM21.5828 5.18554C21.581 6.56938 20.4594 7.69106 19.0755 7.69278H2.92498C3.55759 4.87868 6.07687 2.77112 9.07834 2.77112H21.5828V5.18554Z"
                            fill="#0FC4DC"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2531_1234">
                            <rect width="24.5" height="28" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <h2 class="card-title fw-semibold">
                    Relatório Financial Life Plan
                  </h2>
                  <p class="card-text">
                    Receba o relatório completo da sua vida financeira atual e
                    projeções futuras.
                  </p>
                </div>
              </div>
              <div class="col-md-6" style="height: 15rem">
                <img
                  src="assets/img/image-financial-life-plan.png"
                  class="img-fluid rounded-start h-100"
                  style="
                    object-fit: cover;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
